import { ArrowDown } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowDown = mkIcon(ArrowDown);